export const bottomText = `
  <div data-html="copyright">© 1999-{currentYear}, Rice University. Except where otherwise noted, textbooks on this site
    are licensed under a
    <a href="{copyrightLink}" target="_blank"
    rel="noreferrer">Creative Commons Attribution 4.0 International License</a>.
  </div>
  <div data-html="apStatement">
    Advanced Placement<sup>®</sup> and AP<sup>®</sup> are trademarks registered and/or owned by the College Board,
    which is not affiliated with, and does not endorse, this site.
  </div>
`;

export const missionText = `
  OpenStax is part of Rice University, which is a 501(c)(3) nonprofit.
  <a href="/give" target="_blank">Give today</a> and help us reach more students.
`;
